import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'
import { Language } from '@context'
import AsyncStorage from '@react-native-async-storage/async-storage'

interface UseLanguageStoreState {
  language: Language
  switchLanguage: (language: Language) => void
}

export const useLanguageStore = create<UseLanguageStoreState>()(
  persist(
    (set) => ({
      language: 'fr',
      switchLanguage: (language) => set(() => ({ language })),
    }),
    { name: 'useLanguageStore', storage: createJSONStorage(() => AsyncStorage) },
  ),
)
